import React from "react";
import TableDataGrid from "./TableDataGrid";
import Box from "@mui/material/Box";
import Request from "../Utils/Request/Request";
import { useState, useContext, useEffect } from "react";
import { AppStorage } from "../Utils/Context/AppContext";
import { getErrorMessage, showToast } from "../Utils/index";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PdfIcon from "@mui/icons-material/PictureAsPdf";
import Button from "@mui/material/Button";
import DeleteModal from "./DeleteModal";
import { useNavigate } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import moment from "moment";
import { TextField, Typography } from "@mui/material";
import Loader from "./Loader";
import DialogProducts from "./DialogProducts";
import { useTranslation } from "react-i18next";
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import SalesReturnConfirm from "./SalesReturnConfirm";
import DuplicateModal from "../modals/DuplicateModal";
import ContentCopyIcon  from '@mui/icons-material/ContentCopy';
import AddIcon from '@mui/icons-material/Add';
import { getDocumentId } from "../Utils/documentNumber";
import RemoveIcon from '@mui/icons-material/Remove';
import Tooltip from '@mui/material/Tooltip';
import SendIcon from '@mui/icons-material/Send';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';

const PAGE_SIZE = 7;

const toSafeNumber = (value, fallback = 0) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : fallback;
};

function AllInvoices() {
  const navigate = useNavigate();
  const [openInvoiceProducts, setOpenInvoiceProducts] = useState(false);
  const [openDuplicateModal, setOpenDuplicateModal] = useState(false);
  const [dupInvoice, setDupInvoice] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const { t, i18n } = useTranslation();
  const handleOpenInvoiceProducts = (value) => {
    setOpenInvoiceProducts(true);
    setSelectedItem(value);
  };

  const handleCloseInvoiceProducts = () => {
    setOpenInvoiceProducts(false);
  };

  const [openDelModal, setOpenDelModal] = useState(false);

  const [openSalesConfirm, setOpenSalesConfirm] = useState(false);
  const [returnSale, setReturnSale] = useState(null);
  const OpenSalesModal = (id) => {
    setOpenSalesConfirm(true);
    setReturnSale(id);
  };
  const CloseSalesModal = () => {
    setOpenSalesConfirm(false);
  };

  const OpenDelModal = (user) => {
    setOpenDelModal(true);
    setDelInvoice(user);
  };

  const CloseDelModal = () => {
    setOpenDelModal(false);
  };
  let date = new Date();
  date.setMonth(date.getMonth() - 1);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [delInvoice, setDelInvoice] = useState("");
  const [invoices, setInvoices] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [tableColumns, setTableColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submittingIds, setSubmittingIds] = useState(new Set());
  const [startDate, setStartDate] = useState(date);
  const [endDate, setEndDate] = useState(new Date());
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: PAGE_SIZE,
    total: 0,
  });
  const [searchPhrase, setSearchPhrase] = useState("");


  const AppContext = useContext(AppStorage);

  useEffect(() => {
    const isAdmin = AppContext?.userInfo?.role && AppContext?.userInfo?.role !== "user";
    let cols = [...columns];
    if (Number(AppContext?.userInfo?.zatca_phase) === 2) cols = cols.concat(zatcaColumn);
    if (isAdmin) cols = cols.concat(userColumn);
    cols = cols.concat(actionColumn);
    setTableColumns(cols);
  }, [AppContext?.userInfo, i18n.language, submittingIds]);

  useEffect(() => {
    if (AppContext?.userAuthToken || AppContext?.userAuthToken !== "") {
      getData({ pagination, searchPhrase });
    }
  }, [AppContext?.userAuthToken, pagination?.current, AppContext?.userInfo, AppContext?.zatcaEnvironmentVersion, i18n.language]);

  useEffect(() => {
    if (AppContext?.userInfo?.role === "admin") {
      i18n.changeLanguage("en");
    }
  },[AppContext?.userAuthToken, pagination?.current, AppContext?.userInfo, i18n.language])
  
  useEffect(() => {
    if (forceUpdate) {
      getData({ pagination, searchPhrase, startDate, endDate });
    }
  }, [forceUpdate]);


  
  
  function getData(params) {
    setLoading(true);
    let paramsData = {};

    paramsData = {
      ...paramsData,
      startDate: params?.dateStart || moment.utc(moment(startDate).format().substring(0, 10)).format(),
      endDate: params?.dateEnd || moment.utc(moment(endDate).format().substring(0, 10)).format(),
      searchPhrase: params.searchPhrase,
    };

    Request.get(`/getInvoice/${params.pagination?.current}`, paramsData)
      .then((result) => {
        setLoading(false);
        setInvoices(Array.isArray(result.data["data"]) ? result.data["data"] : []);
        setForceUpdate(false);
        setPagination({
          ...params.pagination,
          current: toSafeNumber(params.pagination?.current, 1),
          pageSize: toSafeNumber(params.pagination?.pageSize, PAGE_SIZE),
          total: toSafeNumber(result.data["totalCount"]),
        });
        setSearchPhrase(params.searchPhrase);
      })
      .catch((err) => {
        setLoading(false);
        console.log("Error: ", err);
        if (err.response.status == 401) {
          showToast("error", "Unauthorized user.");
        } else {
          showToast("error", "Something went wrong.");
        }
      });
  }

  const handleSelect = (date) => {
    const dateStart =  moment.utc(moment(date.selection.startDate).format().substring(0, 10)).format();
    const dateEnd = moment.utc(moment(date.selection.endDate).format().substring(0, 10)).format();
   
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
    
    getData({ pagination, dateStart, dateEnd });
  };
  const handleChange = (event, value) => {
    let dupPagination = { ...pagination };
    dupPagination.current = value;
    setPagination(dupPagination);
  
  };
  function searchChange(value) {
    setSearchPhrase(value)
    setPagination({ ...pagination, current: 1 });
    getData({ pagination: { ...pagination, current: 1 }, searchPhrase: value });
  }

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  };

  // Function to recalculate row numbers
  const updateRowNumbers = () => {
    const invoicesWithRowNumber = invoices.map((invoice, index) => {
      return { ...invoice, rowNumber: (pagination.current - 1) * PAGE_SIZE + (index + 1) };
    });
    setInvoices(invoicesWithRowNumber);
  };

  // Function to handle row deletion
  const handleRowDelete = (selectedRowIds) => {
    const updatedInvoices = invoices.filter(
      (invoice) => !selectedRowIds.includes(invoice.id)
    );
    setInvoices(updatedInvoices);
    updateRowNumbers(); // Recalculate row numbers after deletion
  };

  const columns = [
    { field: "rowNumber", headerName: `${t('SR-NO.')}`, width: 70 },
    { field: "i_document_number", headerName: `${t('Invoice No.')}`, width: 120, renderCell: (params) => getDocumentId(params.row) },
    { field: "companyName", headerName: `${t("Company Name")}`, width: 200 },
    { field: "vatNumber", headerName: `${t("Vat Number")}`, width: 100 },
    { field: "total", headerName: `${t("Total")}`, width: 120 },
    {
      field: "invoiceproducts",
      headerName: `${t("No. of Products")}`,
      renderCell: (text) => {
        return (
          <div>
            <Button
              variant="outlined"
              onClick={() => handleOpenInvoiceProducts(text)}
            >
              {text?.value?.length}
            </Button>
          </div>
        );
      },
      width: 150,
    },
    { field: "po", headerName: "P.O", width: 100 ,
    renderCell: (text) => (
      <span>{text?.value || "N/A"}</span>
    )
    },
    { field: "payment", headerName: `${t("Payment")}`, width: 100,
    renderCell: (text) => (
      <span>{text?.value || "N/A"}</span>
    )
    }, 
    {
      field: "invoiceDate",
      headerName: `${t("Invoice Date")}`,
      renderCell: (text) => (
        <span>{moment.utc(text?.value).format("YYYY-MM-DD")}</span>
      ),
      width: 130,
    },
  ];

  const submitToZatca = (invoiceId) => {
    setSubmittingIds((current) => new Set(current).add(invoiceId));
    Request.post(`/invoice/${invoiceId}/zatca-send`, {})
      .then((result) => {
        showToast("success", t("Invoice submitted to ZATCA successfully."));
        const zatcaData = result?.data?.data;
        if (zatcaData) {
          setInvoices((current) =>
            current.map((invoice) =>
              invoice.id === invoiceId ? { ...invoice, ...zatcaData } : invoice
            )
          );
        }
      })
      .catch((err) => {
        showToast("error", getErrorMessage(err, t("ZATCA submission failed.")));
      })
      .finally(() => {
        setSubmittingIds((current) => {
          const next = new Set(current);
          next.delete(invoiceId);
          return next;
        });
      });
  };

  const zatcaColumn = {
    field: "zatca_status",
    headerName: t("ZATCA Status"),
    width: 150,
    sortable: false,
    renderCell: (params) => {
      const status = String(params.value || "PENDING").toUpperCase();
      const badges = {
        CLEARED: { bg: "#e8f5e9", color: "#2e7d32", label: "CLEARED" },
        REPORTED: { bg: "#e3f2fd", color: "#1565c0", label: "REPORTED" },
        FAILED: { bg: "#ffebee", color: "#c62828", label: "FAILED" },
        PENDING: { bg: "#fff8e1", color: "#f57f17", label: "PENDING" },
        SKIPPED: { bg: "#f3f3f3", color: "#757575", label: "SKIPPED" },
        NONE: { bg: "#f3f3f3", color: "#9e9e9e", label: "LEGACY" },
      };
      const badge = badges[status] || { bg: "#f3f3f3", color: "#555", label: status };
      return (
        <Box
          component="span"
          sx={{
            display: "inline-block",
            px: 1.25,
            py: 0.25,
            borderRadius: 3,
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.5px",
            backgroundColor: badge.bg,
            color: badge.color,
            border: `1px solid ${badge.color}44`,
          }}
        >
          {badge.label}
        </Box>
      );
    },
  };

  let actionColumn = [
    {
      field: "actions",
      headerName: `${t("Actions")}`,
      width: 190,
      sortable: false,
      filterable: false,
      renderCell: (record) => {
        const isPhase2 = Number(AppContext?.userInfo?.zatca_phase) === 2;
        const returnType = record.row?.zatca_return_type;
        const zatcaStatus = String(record.row?.zatca_status || "PENDING").toUpperCase();
        const canSubmitToZatca = isPhase2 && ["PENDING", "FAILED"].includes(zatcaStatus);
        const isSubmittingToZatca = submittingIds.has(record.row.id);

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              height: "100%",
              "& .MuiSvgIcon-root": { display: "block" },
            }}
          >
            {(AppContext?.userInfo?.role === "admin" || AppContext?.userInfo?.role === "user") &&(
                <PdfIcon
                  sx={{ cursor: "pointer", color: "#FF0000", display: "block" }}
                  onClick={() => printInvoice(record.row)}
                  />
            )} 
             {(AppContext?.userInfo?.role === "admin" || AppContext?.userInfo?.role === "sub-admin" &&
             AppContext?.userInfo.canDelete === true ) && (
              
                  <EditIcon
                  onClick={() => UpdateClientModal(record.row)}
                  // console.log(record.row)
                  sx={{ cursor: "pointer", color: "#41c1ba" }}
                /> 
              
              )}
            
            {(AppContext?.userInfo?.role === "admin" || AppContext?.userInfo?.role === "sub-admin" &&
             AppContext?.userInfo.canDelete === true) && (
            <DeleteIcon
              sx={{ cursor: "pointer", color: "#365b6d" }}
              onClick={() => OpenDelModal(record.row)}
            />
            )}
            {AppContext?.userInfo?.role === "user" && (
              isPhase2 && returnType ? (
                <Tooltip title={t(returnType === "CREDIT_NOTE" ? "Credit Note" : "Debit Note")}>
                  <Box component="span" sx={{ display: "inline-flex" }}>
                    {returnType === "CREDIT_NOTE" ? (
                      <RemoveIcon sx={{ color: "#d32f2f" }} />
                    ) : (
                      <AddIcon sx={{ color: "#2e7d32" }} />
                    )}
                  </Box>
                </Tooltip>
              ) : (
                <KeyboardReturnIcon
                  sx={{ cursor: "pointer", color: "#365b6d" }}
                  onClick={() => OpenSalesModal(record?.row)}
                />
              )
            )}
            {(AppContext?.userInfo?.role === "user") && (
            <ContentCopyIcon
              sx={{ cursor: "pointer", color: "#365b6d" }}
              onClick={() => duplicateInvoice(record?.row)} 
            />
            )}
            {canSubmitToZatca && (
              <Tooltip title={t("Send to ZATCA")}>
                <span>
                  <IconButton
                    size="small"
                    disabled={isSubmittingToZatca}
                    onClick={(event) => {
                      event.stopPropagation();
                      submitToZatca(record.row.id);
                    }}
                    sx={{ color: "#365b6d", p: 0, width: 24, height: 24 }}
                  >
                    {isSubmittingToZatca ? <CircularProgress size={18} /> : <SendIcon fontSize="small" />}
                  </IconButton>
                </span>
              </Tooltip>
            )}
          </Box>
        );
      },
    },
  ];

  let userColumn = [
    { 
      field: "user", headerName: "User Name",
      renderCell: (text) => {
        return (
          <div> {text.value?.fullName}</div>
        );
      },
      width: 70
    },
  ];

  const handleSalesReturn = (id, returnType) => {
    const isPhase2 = Number(AppContext?.userInfo?.zatca_phase) === 2;
    if (isPhase2) {
      CloseSalesModal();
      navigate(`/duplicateInvoice/${id}?returnType=${returnType}`);
      return;
    }

    Request.put(`/updateSalesReturn/${id}`, { salesReturn: true })
      .then((result) => {
        CloseSalesModal();
        showToast(
          "success",
          t("Invoice has been moved to sales returned")
        );
        getData({ pagination, searchPhrase });
      })
      .catch((err) => {
        console.log("Error: ", err);
        if (err.response.status == 401) {
          showToast("error", "Unauthorized user.");
        } else {
          showToast("error", getErrorMessage(err, t("Something went wrong.")));
        }
      });
  };
  
  function printInvoice(invoice) {
    // if(AppContext?.userInfo.invoiceType != "normal" && AppContext?.userInfo.invoiceType != "simple"){
  //   window.open(`/invoice_custom/${invoice.id}`, "_blank")?.focus();
  // }else{
    window.open(`/invoice/${invoice.id}`, "_blank")?.focus();
  // }
}
  
  function UpdateClientModal(invoice) { 
      navigate(`/updateInvoice/${invoice.id}`);
    {AppContext?.userInfo?.role === "user" ? showToast("info", "Edit Description Only.") : showToast("info", "Edit Invoice No.Only.");}
    
  }

  function duplicateInvoice(invoice) { 
    setOpenDuplicateModal(true)
    setDupInvoice(invoice)
  }
  
  function navigateDuplicateInvoice(invoice){
    navigate(`/duplicateInvoice/${invoice.id}`);
  }

  function deleteInvoice(invoice) {
    Request.delete(`/delInvoice/${invoice["id"]}`)
      .then(() => {
        setForceUpdate(true);
        CloseDelModal();
        showToast("success", "Deleted Successfully.");
      })
      .catch((err) => {
        console.log("Error: ", err);
        if (err.response.status == 401) {
          showToast("error", "Unauthorized user.");
        } else {
          showToast("error", "Something went wrong.");
        }
      });
  }
  const normalizeDate = (date) => {
    const normalized = new Date(date);
    normalized.setUTCHours(0, 0, 0, 0);
    return normalized;
  };
  const showInvoiceDate = AppContext?.userInfo?.showInvoice ? new Date(AppContext?.userInfo?.showInvoice) : null;
  const createInvoice = AppContext?.userInfo?.createInvoice ? new Date(AppContext?.userInfo?.createInvoice) : null;
  const currentDate = normalizeDate(new Date());  
  
  return (
    <Box className="portal-list-page">

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          width: "100%",
          marginBottom: "0px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", sm: "nowrap" },
            alignItems: "center",
            gap: { xs: 1.5, sm: 0 },
            width: { xs: "100%", md: "auto" },
          }}
        >
        <Box
          onClick={() => setShowDatePicker(true)}
          onMouseEnter={() => setShowDatePicker(true)}
          onMouseLeave={() => setShowDatePicker(false)}
          sx={{
            width: { xs: "auto", sm: "332px" },
            flex: { xs: "1 1 0", sm: "0 0 auto" },
            minWidth: 0,
            position: "relative",
            "& .rdrDateRangePickerWrapper": {
              width: "100%",
              "& .rdrCalendarWrapper ": {
                width: "100%",
              },
            },
            "& .rdrMonthAndYearWrapper": {
              position: "absolute",
              top: 70,
              background: "white",
              width: "100%",
              display: showDatePicker ? "" : "none",
              zIndex: 999,
              boxShadow: "0px 3px 8px rgb(100,100,100)",
            },
            "& .rdrMonths ": {
              position: "absolute",
              top: 130,
              background: "white",
              display: showDatePicker ? "" : "none",
              zIndex: 999,
              boxShadow: "0px 3px 8px rgb(100,100,100)",
            },
          }}
        >
          <DateRangePicker
            ranges={[selectionRange]}
            onChange={handleSelect}
            moveRangeOnFirstSelection={false}
            retainEndDateOnFirstSelection={true}
          />
        </Box>

        {(AppContext?.userInfo?.role === "user" && createInvoice === null || createInvoice >= currentDate) && (
          <Button
            className="smallScreen-btn"
            onClick={() => navigate(`/addInvoice`)}
            variant="contained"
            aria-label={t("ADD NEW INVOICE")}
            sx={{
              fontSize: "30px",
              background: "#365b6d",
              "&:hover": { backgroundColor: "#365b6d" },
              height: "44px",
              minWidth: "44px",
              padding: 0,
              textAlign: "center",
              marginTop: "9.996px"
            }}
          >
            +
          </Button>
        )}

        <Box sx={{ display: "flex", alignItems: "center", flexBasis: { xs: "100%", sm: "auto" }, width: { xs: "100%", sm: "auto" } }}>
          <TextField
            type="text"
            autoComplete="off"
            placeholder= {t("Search Company/Invoice NO.")}
            onChange={(event) => searchChange(event.target.value)}
            sx={{
              width: { xs: "100%", sm: "250px" },
              marginRight: { xs: 0, sm: "20px" },
              "& .MuiOutlinedInput-input": { height: "1em" },
              "& fieldset": {
                borderColor: "#365b6d !important",
              },
            }}
          />
        </Box>
        </Box>
        {(AppContext?.userInfo?.role === "user" && createInvoice === null || createInvoice >= currentDate) && (

        
          <Box sx={{ display: "flex", alignItems: "center", gap:"10px" }}>
            <Button
              className="largeScreen-btn"
              onClick={() => navigate(`/addInvoice`)}
              variant="contained"
              sx={{
                background: "#365b6d",
                "&:hover": { backgroundColor: "#365b6d" },
                height: "40px",
              }}
            >
            {t("ADD NEW INVOICE")}
            </Button>            
          </Box>
        )}
      </Box>

      <div className="portal-list-body">
        <Typography variant="h6" sx={{ color: "#365b6d", textAlign: "center" }}>
          {t("All Invoices")}
        </Typography>
        <>
    {showInvoiceDate === null || showInvoiceDate >= currentDate ? (
      loading ? (
        <Loader />
      ) : (
        <>
          <TableDataGrid
            // rows={invoices}
            rows={invoices.map((invoice, index) => ({
              ...invoice,
              tableRowId: invoice.id || `${getDocumentId(invoice) || "invoice"}-${index}`,
              rowNumber: (pagination.current - 1) * PAGE_SIZE + (index + 1),
            }))}
            getRowId={(row) => row.tableRowId}
            columns={tableColumns}
            disableColumnMenu
            hideFooter
            checkboxSelection={false}
            disableSelectionOnClick
            sx={{ background: "white" }}
            onSelectionModelChange={(newSelection) =>
              handleRowDelete(newSelection)
            }
          />
          <Stack spacing={2} marginTop="5px">
            <Pagination
              count={Math.max(1, Math.ceil(toSafeNumber(pagination?.total) / PAGE_SIZE))}
              page={toSafeNumber(pagination?.current, 1)}
              onChange={handleChange}
            />
          </Stack>
        </>
      )
    ) : (
      <div style={{display:"flex", alignItems:"center", justifyContent:"center", height:"100%"}}>
        <p style={{color:"rgb(61 145 255)"}}>{t("Unfortunately, this service cannot be accessed. Contact the support person responsible for your account")}</p></div>
    )}
  </>
      </div>
      <DialogProducts
        handleCloseInvoiceProducts={handleCloseInvoiceProducts}
        openInvoiceProducts={openInvoiceProducts}
        text={selectedItem}
      />
      {openDelModal && (
        <DeleteModal
          del={deleteInvoice}
          currentUser={delInvoice}
          openDelModal={openDelModal}
          setDeleteModal={setOpenDelModal}
        />
      )}
      {openSalesConfirm && (
        <SalesReturnConfirm
          moveToReturn={handleSalesReturn}
          currentInvoice={returnSale}
          openSalesModal={openSalesConfirm}
          setOpenSalesModal={setOpenSalesConfirm}
          isPhase2={Number(AppContext?.userInfo?.zatca_phase) === 2}
        />
      )}
      {openDuplicateModal && (
        <DuplicateModal
          currentUser={dupInvoice}
          openDuplicateModal={openDuplicateModal}
          setDuplicateModal={setOpenDuplicateModal}
          duplicateUser={navigateDuplicateInvoice}
        />
      )}
    </Box>
  );
}

export default AllInvoices;
